<template>
  <v-dialog v-model="invitationDialog" persistent width="500px">
    <v-card>
      <v-card-title> マスターユーザー招待 </v-card-title>
      <v-card-text>
        <v-form ref="form">
          1.招待するユーザーの権限を選択してください。
          <v-select
            v-model="masterAccess"
            label="ユーザータイプ"
            :items="selectableMasterAccesses"
            item-text="type"
            item-value="value"
            :rules="[masterAccessValidation]"
            required
            clearable
          />
          2.招待対象のサイトを選択してください。
          <v-select
            v-model="selectedAddSiteKey"
            label="招待サイト"
            :items="allSiteKeys"
            item-text="name"
            item-value="siteKey"
            clearable
          />
          3.招待するメールアドレスを入力してください。
          <v-text-field
            v-model="email"
            label="招待メールアドレス"
            type="email"
            :rules="[emailValidation]"
            required
            crearable
          />
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn color="error darken-1" text @click="closeDialog">
          キャンセル
        </v-btn>
        <v-btn color="green darken-1" text @click="inviteUserAuth">
          招待する
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from 'axios'
import { deserialize } from 'deserialize-json-api'

export default {
  props: {
    invitationDialog: {
      type: Boolean,
      required: true
    }
  },
  data: () => {
    return {
      masterAccess: null,
      email: null,
      selectableMasterAccesses: [
        { type: '最高管理者', value: 1 },
        { type: '管理者', value: 4 },
        { type: 'ライター', value: 2 },
        { type: 'クライアント', value: 3 }
      ],
      allSiteKeys: [],
      selectedAddSiteKey: null,
      emailValidation: (value) => {
        if (!value) {
          return '必ず入力してください'
        }
        const res = value.match(
          /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/
        )
        if (res == null) {
          return '正しいeメールアドレスを入力してください'
        } else {
          return true
        }
      },
      masterAccessValidation: (value) => {
        if (!value) {
          return '必ず入力してください'
        } else {
          return true
        }
      }
    }
  },
  mounted: function () {
    axios.get(`/api/master/sites`).then((data) => {
      this.allSiteKeys = deserialize(data.data).data
    })
  },
  methods: {
    closeDialog () {
      this.$emit('close-dialog')
      this.email = null
      this.masterAccess = null
      this.selectedAddSiteKey = null
      this.$refs.form.resetValidation()
    },
    inviteUserAuth () {
      this.$refs.form.validate()
      if (this.$refs.form.validate()) {
        this.$emit('invite-user-auth', this.masterAccess, this.email, this.selectedAddSiteKey)
        this.closeDialog()
      }
    }
  }
}
</script>

<style scoped></style>
